import { DEFAULT_PLAYOFF_SEEDS, playoffSeeds } from '../mlbb/novaBracketEngine';

export default function PlayoffSeedsEditor({ tour, onChange }) {
  let seeds;
  try { seeds = playoffSeeds(tour.playoffSeeds); }
  catch { seeds = DEFAULT_PLAYOFF_SEEDS; }
  const change = (index, value) => {
    const next = [...seeds];
    const other = next.indexOf(value);
    [next[index], next[other]] = [next[other], next[index]];
    onChange(next);
  };
  return <div className="fed-admin-view">
    <h3 className="font-bold mb-3">Сетка плей-офф</h3>
    <p className="text-fg-muted text-sm mb-4">Выберите места групп для четвертьфиналов. При выборе занятого места участники меняются местами. Полуфинал 1: победители ЧФ1 и ЧФ2; полуфинал 2: победители ЧФ3 и ЧФ4. Изменения публикуются после сохранения турнира. Результаты изменившихся пар потребуют повторного ввода.</p>
    <div className="grid gap-4 md:grid-cols-2">
      {[0, 1, 2, 3].map((quarter) => <div key={quarter} className="rounded-xl border border-line p-4">
        <h4 className="font-bold mb-3">Четвертьфинал {quarter + 1}</h4>
        {[0, 1].map((side) => {
          const index = quarter * 2 + side;
          return <label key={side} className="flex flex-col gap-2 mb-3">
            Участник {side + 1}
            <select className="fed-input" aria-label={`ЧФ${quarter + 1}: участник ${side + 1}`} value={seeds[index]} onChange={(event) => change(index, event.target.value)}>
              {DEFAULT_PLAYOFF_SEEDS.map((seed) => {
                const [group, place] = seed.split(':').map(Number);
                return <option key={seed} value={seed}>Группа {tour.groups[group].id} · {place}-е место</option>;
              })}
            </select>
          </label>;
        })}
      </div>)}
    </div>
    <button type="button" className="fed-btn-ghost px-4 py-2 mt-4" onClick={() => onChange([...DEFAULT_PLAYOFF_SEEDS])}>Восстановить перекрёстные пары 1–2 и 3–4</button>
  </div>;
}
